export default class ErrorCdMsgConstants {
  // サーバー切断のエラー コードとメッセージ ===================================================================
  /** バックエンド接続エラーコード。 */
  static FUNC_BACKEND_CONNECTION_ERR_CD = 'BBA001';
  /** バックエンド接続エラーメッセージ。 */
  static FUNC_BACKEND_CONNECTION_ERR_MSG = '+Hubに接続されていません。';

  /** ネットワークプロキシサーバエラーコード。 */
  static FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_CD = 'BBA002';
  /** ネットワークプロキシサーバエラーメッセージ。 */
  static FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_MSG =
    'ネットワークに接続されていません。Wi-Fiがオンになっていること、正しいネットワークに接続されていることを確認し、再試行してください。';

  /** サーバー切断エラーコード一覧。 */
  static SERVER_DISCONNECTION_ERR_CD_LIST = [
    ErrorCdMsgConstants.FUNC_BACKEND_CONNECTION_ERR_CD,
    ErrorCdMsgConstants.FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_CD
  ];
  // =======================================================================================================================

  // 認証エラーコードとメッセージ =====================================================================
  /** 認証エラーコード。 */
  static FUNC_AUTH_ERR_CD = 'BDB001';
  /** 認証エラーメッセージ。 */
  static FUNC_AUTH_ERR_MSG = '社員IDに誤りがあります。+Hub BASE画面から社員IDをご確認ください。';
  // =======================================================================================================================

  // スキャン機能のエラーコードとメッセージ =====================================================================
  /** 未完了タスクを取得するためのマルチソートエラーコード。 */
  static FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MULTI_SORT_ERR_CD = 'BAF010';
  /** 手動ソートでスキャンしている間、タスクはエントリーを超過するエラーコード. */
  static FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MANUAL_SORT_ERR_CD = 'BAF011';
  /** スキャン確定詳細メッセージ 未完了タスク取得エラーメッセージ。*/
  static FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_ERR_MSG =
    '過剰投入です。投入した商品は、投入数の上限を超えたか仕分けが完了しています。';

  /** 単一ソートの関数スキャン確認無効なスキャンコードフィールド名エラーコード。 */
  static FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_SINGLE_SORT_ERR_CD = 'BBF001';
  /** 一括ソートによる関数スキャン確認の無効なスキャン コード フィールド名エラーコード。 */
  static FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_MULTI_SORT_ERR_CD = 'BBF002';
  /** 手動ソートによる関数スキャン確認の無効なスキャンコードフィールド名エラーコード。 */
  static FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_MANUAL_SORT_ERR_CD = 'BBF003';
  /** 作業指示ソートのない機能スキャン確認無効なスキャンコードフィールド名エラーコード。 */
  static FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_NO_TASK_SORT_ERR_CD = 'BBF004';
  /** 機能 スキャン確認 無効なスキャン コード フィールド名 タスクなし マルチ ソート エラー コード */
  static FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_NO_TASK_MULTI_SORT_ERR_CD = 'BBF008';
  /** 機能スキャン確認無効なスキャン コード フィールド名エラーメッセージ。 */
  static FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_ERR_MSG = '%sが読み取れませんでした。';

  /** 機能スキャン確認最大入力量を超えていますマルチソートエラーコード */
  static FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_MULTI_SORT_ERR_CD = 'BBF010';
  /**機能スキャン確認最大入力量を超えています手動ソートエラーコード */
  static FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_MANUAL_SORT_ERR_CD = 'BBF011';
  /** 機能スキャン確認最大入力量を超えていますタスクなしマルチソートエラーコード */
  static FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_NO_TASK_MULTI_SORT_ERR_CD = 'BBF007';
  /** 機能スキャン確認の最大入力数量を超えたエラー メッセージ */
  static FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_ERR_MSG =
    '投入数の上限を超えています。投入数を上限{0}以下にしてください。';
  /** RFIDスキャンが一致しない場合のエラーコード。*/
  static FUNC_SCAN_CONFIRM_NON_MATCH_RFID_SINGLE_SORT_ERR_CD = 'BBF009';
  /** RFID の不一致をスキャンするときのエラー メッセージ。*/
  static FUNC_SCAN_CONFIRM_NON_MATCH_RFID_SINGLE_SORT_ERR_MSG =
    'スキャンできませんでした。再度商品をかざしてください。';

  /** マルチソートの入力数量が不正な場合のエラーコード。*/
  static FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MULTI_SORT_ERR_CD = 'BBF005';
  /** マルチソートの入力数量が不正な場合のエラーメッセージ。*/
  static FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MULTI_SORT_ERR_MSG =
    '投入数に誤りがあります。投入数は1以上にして発進してください。';
  /** 手動仕分けの入力数量が不正な場合のエラーコード。*/
  static FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MANUAL_SORT_ERR_CD = 'BBF006';
  /** 手動仕分けの入力数量が無効な場合のエラー メッセージ。*/
  static FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MANUAL_SORT_ERR_MSG =
    '投入数に誤りがあります。投入数は1以上にして完了してください。';
  /** タスクなしマルチソートの入力数量が不正な場合のエラーコード。*/
  static FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_NO_TASK_MULTI_SORT_ERR_CD = 'BBF012';
  /** タスクなしマルチソートの入力数量が無効な場合のエラーメッセージ。*/
  static FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_NO_TASK_MULTI_SORT_ERR_MSG =
    '投入数に誤りがあります。投入数は1以上にして発進してください。';
  // =======================================================================================================================

  // 誘導エラーコードとメッセージを選択せずにモードを選択します ====================================================
  /** 誘導エラーコードを選択せずにモードを選択してください。 */
  static FUNC_SELECT_MODE_WITHOUT_SELECTING_INDUCTION_ERR_CD = 'BAL001';
  /** 誘導エラーメッセージを選択せずにモードを選択してください。 */
  static FUNC_SELECT_MODE_WITHOUT_SELECTING_INDUCTION_ERR_MSG =
    '初期設定が完了していません。インダクションを選択してください。';
  // =======================================================================================================================

  // インダクションの設定が必要であることを示すエラーコードおよびエラーメッセージ ==========================================
  /** 必要な選択誘導画面を開いたが選択されていないエラーコード。 */
  static FUNC_WITHOUT_SELECTING_INDUCTION_ON_REQUIRED_SCREEN_ERR_CD = 'BAA002';
  /** 必要な選択誘導画面を開きますが、選択されていないエラー メッセージ。 */
  static FUNC_WITHOUT_SELECTING_INDUCTION_ON_REQUIRED_SCREEN_ERR_MSG =
    '初期設定が完了していません。インダクションを選択してください。';
  /** 休憩のためにインダクション設定が必要であることを示すエラーコード。 */
  static FUNC_WITHOUT_SELECTING_INDUCTION_SETTING_REQUIRED_TO_TAKE_BREAK_ERR_CD = 'BAA003';
  /** 休憩のためにインダクション設定が必要であることを示すエラーメッセージ。 */
  static FUNC_WITHOUT_SELECTING_INDUCTION_SETTING_REQUIRED_TO_TAKE_BREAK_ERR_MSG =
    '休憩を行うにはインダクションの設定が必要です。インダクションを選択してください。';
  /** 仕分けのためにインダクション設定が必要であることを示すエラーコード。 */
  static FUNC_WITHOUT_SELECTING_INDUCTION_SETTING_REQUIRED_TO_RESUME_ERR_CD = 'BAR001';
  /** 仕分けのためにインダクション設定が必要であることを示すエラーメッセージ。 */
  static FUNC_WITHOUT_SELECTING_INDUCTION_SETTING_REQUIRED_TO_RESUME_ERR_MSG =
    '仕分けを行うにはインダクションの設定が必要です。インダクションを選択してください。';
  // =======================================================================================================================
  /** タスクタイプの投入方法が更新され、単一投入とまとめ投入を切り替えることができない場合のエラーコード。 */
  static FUNC_SELECT_MODE_UNCHANGEABLE_ERR_CD = 'BBO001';
  /** タスクタイプの投入方法が更新され、単一投入とまとめ投入を切り替えることができない場合のエラーメッセージ。 */
  static FUNC_SELECT_MODE_UNCHANGEABLE_ERR_MSG =
    '投入方法の設定が変更されたため、切り替えはできません。そのまま作業を続けるか、商品仕分けのモードを変更してください。';
  // =======================================================================================================================

  // 警告メッセージ ============================================================================================
  /** 数量変更警告メッセージ。*/
  static CHANGED_QUANTITY_WARNING_MESSAGE = '投入できる数が変わりました。';
  // =======================================================================================================================
}
